const noop = () => {};

export default function gatewayMiddleware(validator, actionCreator = noop) {
  return store => next => action => {
    if (validator(store.getState(), action)) {
      return next(action);
    }

    return next(actionCreator());
  };
}



// WEBPACK FOOTER //
// ./src/store/middleware/gatewayMiddleware.js